<template>
  <div
    v-if="open"
    class="fixed left-0 top-0 z-50 flex h-full w-full items-center justify-center backdrop-blur-[1px] backdrop-brightness-50"
    :data-testId="dataTestId"
  >
    <div
      class="relative max-w-2xl rounded-3xl bg-white py-4 shadow dark:bg-dark-3"
    >
      <button
        type="button"
        class="absolute right-4 top-4 ml-auto inline-flex items-center rounded-lg bg-transparent px-2 py-1.5 text-2xl text-black hover:bg-gray-200 hover:text-gray-900 dark:text-gray-300 dark:hover:bg-dark-4 dark:hover:text-white"
        data-modal-hide="popup-modal"
        data-testId="closePromptBtn"
        @click="close"
      >
        <em class="mdi mdi-close" />
      </button>
      <div class="flex flex-col gap-5 px-10 py-5 text-center">
        <div>
          <em v-if="showIcon" class="mdi text-5xl" :class="icon" />
          <div
            v-if="title"
            :class="[
              'mx-auto mt-5 max-w-[75%]  text-xl  font-bold',
              { 'mt-6': !showIcon },
            ]"
          >
            {{ title }}
          </div>
        </div>
        <span
          v-if="question"
          class="mx-auto max-w-[90%] whitespace-pre-line text-left"
        >
          {{ question }}
        </span>
        <div class="max-h-[80vh] overflow-auto">
          <slot></slot>
        </div>
        <div class="my-4 border-b-2 border-gray-400 dark:border-dark-4"></div>
        <div
          v-if="showActions"
          :class="[
            'flex flex-row gap-5',
            { 'justify-center': cancelText, 'justify-end': !cancelText },
          ]"
        >
          <TertiaryButton
            v-if="cancelText"
            :label="cancelText"
            data-testid="cancelPromptBtn"
            @click="cancel"
          />
          <PrimaryButton
            :label="proceedText"
            :is-disabled="proceedDisabled"
            :is-muted="proceedDisabled"
            data-testid="confirmPromptBtn"
            @click="proceed"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import TertiaryButton from '@/components/UI/Button/TertiaryButton.vue';
import PrimaryButton from '@/components/UI/Button/PrimaryButton.vue';
interface Props {
  open: boolean;
  close: () => void;
  cancel: () => void;
  proceed?: () => void;
  showIcon?: boolean;
  icon?: string;
  title?: string;
  question?: string;
  cancelText?: string;
  proceedText?: string;
  showActions?: boolean;
  dataTestId?: string;
  proceedDisabled?: boolean;
}
const props = withDefaults(defineProps<Props>(), {
  proceed: undefined,
  icon: 'mdi-alert-outline text-light-warning dark:text-dark-warning',
  title: undefined,
  question: undefined,
  cancelText: 'Abbrechen',
  proceedText: 'Bestätigen',
  dataTestId: undefined,
  showActions: true,
  showIcon: true,
  proceedDisabled: false,
});
</script>
